<template>
  <div>
    <b-row>
      <b-col
        xl="12"
        lg="12"
        md="4"
        sm="6"
        xs="6"
      >
        <b-row>
          <b-col
            v-for="(item, index) in video.slice(0, 2)"
            :key="index"
            cols="6"
          >
            <br>
            <b-card
              no-body
              style="width:100%;"
            >
              <video
                :id="'video' + index"
                :src="item.video"
                style="flex-direction: row;"
                width="auto"
                height="400"
                muted
                autoplay
                loop
              />
              <b-card-text style="color: #ffffff;">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+1 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            v-for="(item, index) in video.slice(2, 5)"
            :key="index"
            cols="4"
          >
            <br>
            <b-card
              no-body
              style="width:100%;"
            >
              <video
                :id="'video' + index"
                :src="item.video"
                style="flex-direction: row;"
                width="auto"
                height="310"
                muted
                autoplay
                loop
              />
              <b-card-text style="color: #ffffff;">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+3 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
  },
  data() {
    return {
      video: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getVideo()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getVideo()
    }, 300000)
  },
  methods: {
    getVideo() {
      axios
        .post('/getVMSDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.video = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
  </style>
